import { MoveFocusInside } from 'react-focus-on';
import { useModalContentManager } from '@provider/notifier';
import { Button } from '@ui/kit';
import { FloppyIcon } from '@ui/kit/icons';
import { modal, heading, text, buttonsWrapper } from './_shared.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

const makeLeaveExistingRevisionModalConfig = options => ({
  theme: "dialog",
  className: modal,
  requiresAction: options?.requiresInteraction,
  content: /*#__PURE__*/jsx(LeaveExistingRevisionModal, {
    revision: options.revision
  })
});
function LeaveExistingRevisionModal(props) {
  const manager = useModalContentManager();
  return /*#__PURE__*/jsxs("div", {
    children: [/*#__PURE__*/jsxs("h1", {
      className: heading,
      children: ["Vil du gemme \xE6ndringer til \u2018", props.revision.name, "\u2019?"]
    }), /*#__PURE__*/jsx("p", {
      className: text,
      children: "Hvis du gemmer, overskriver du den eksisterende version med de nye \xE6ndringer og versionen bliver opdateret hos de elever, du tidligere har delt med."
    }), /*#__PURE__*/jsxs("div", {
      className: buttonsWrapper,
      children: [/*#__PURE__*/jsx(Button, {
        theme: "secondary",
        onClick: () => manager.onDismiss({
          intent: "do-not-save"
        }),
        children: "Gem ikke"
      }), /*#__PURE__*/jsx(MoveFocusInside, {
        children: /*#__PURE__*/jsx(Button, {
          theme: "primary",
          icon: /*#__PURE__*/jsx(FloppyIcon, {}),
          onClick: () => manager.onDismiss({
            intent: "save"
          }),
          children: "Gem \xE6ndringer"
        })
      })]
    })]
  });
}

export { makeLeaveExistingRevisionModalConfig };
//# sourceMappingURL=leave.existing.js.map
